import { ActionModuleInstanceCompletedAuditLogItem, AuditLogItem, PermissionsAuditLogItem, UserAuditLogItem } from "../../../types/auditLogTypes";
import { useTranslation } from "react-i18next";
import { BasicTableRowStyles } from "../../../components/common/Common.styles";
import CellBox from "../../../components/common/table/CellBox";
import TooltipTypography from "../../../components/common/TooltipTypography";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

interface AuditLogsTableRowProps {
    item: AuditLogItem;
}

export default function AuditLogsTableRow({ item}: AuditLogsTableRowProps) {
    const { t } = useTranslation();

    const hasAffectedUser = isUserAuditLogItem(item) || isPermissionsAuditLogItem(item);

    const affectedUserName = hasAffectedUser
        ? item.affectedUserName 
        : "";
    const affectedUserIsDeleted = hasAffectedUser
        ? item.affectedUserIsDeleted 
            ? t("tableColumnRows.yes") 
            : t("tableColumnRows.no") 
        : "";
    const permissionName = isPermissionsAuditLogItem(item)
        ? item.permissionName 
        : "";
    const entityType = isPermissionsAuditLogItem(item)
        ? t(`auditLogsPage.entityType.${item.entityType}`)
        : "";
    const actionModuleName = isActionModuleInstanceCompletedAuditLogItem(item)
        ? item.actionModuleName 
        : "";

    return (
        <BasicTableRowStyles style={{ cursor: "default" }}>
            <CellBox firstCol stickyFirstCol>
                <TooltipTypography
                    value={dayjs(item.timestamp).format("YYYY-MM-DD HH:mm:ss")}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={item.userName}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={t(`auditLogsPage.auditLogType.${item.type}`)}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={affectedUserName}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={affectedUserIsDeleted}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={entityType}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={permissionName}
                />
            </CellBox>
            <CellBox>
                <TooltipTypography
                    value={actionModuleName}
                />
            </CellBox>
        </BasicTableRowStyles>
    );
};

function isUserAuditLogItem(item: AuditLogItem): item is UserAuditLogItem {
    return item.type === "UserCreated" || item.type === "UserDeleted";
};

function isPermissionsAuditLogItem(item: AuditLogItem): item is PermissionsAuditLogItem {
    return item.type === "PermissionAdded" || item.type === "PermissionRevoked";
};

function isActionModuleInstanceCompletedAuditLogItem(item: AuditLogItem): item is ActionModuleInstanceCompletedAuditLogItem {
    return item.type === "ActionModuleInstanceCompletey";
};